import React from "react";
import ProgressBar from "../../../../UI/ProgressBar";
import { BreadcrumbAdmin } from "../../../../UI/BreadcrumbAdmin";
import { PromotionsEligibilityFilters } from "../../../Promotions/PromotionsEligibilityFilters";
import { PromotionsBookTabs } from "../../../Promotions/PromotionsBookTabs";
import { PromotionsEligibilityTable } from "../../../Promotions/PromotionsEligibilityTable";
import { usePromotionsEligibilityList } from "../../../Promotions/usePromotionsEligibilityList";
import { PROMOTIONS_LIST_MODES } from "../../../Promotions/promotionListModes";
import "../../../Promotions/Promotions.css";
import "../../../../Admin/Reports/Reports Detailed/ReportsDetailed.css";

const breadcrumbBase = [
  {
    _id: 1,
    link: "/super-admin/reports",
    label: "Reports",
  },
];

export const PromotionsReport = () => {
  const list = usePromotionsEligibilityList(PROMOTIONS_LIST_MODES.REPORT);

  if (list.booksLoading) {
    return <ProgressBar />;
  }

  return (
    <div className="container">
      <BreadcrumbAdmin base={breadcrumbBase} page="Promotions" />
      <p className="reportsDetailed__subtitle">
        Eligible employees by organisation book, with contact and promotion
        status across the lifecycle from book completion to promotion completed.
      </p>

      <div className="promotions-page">
        <div className="promotions-report__filters">
          <PromotionsEligibilityFilters
            mode={PROMOTIONS_LIST_MODES.REPORT}
            searchInput={list.searchInput}
            onSearchChange={list.onSearchChange}
            dateField={list.dateField}
            dateStart={list.dateStart}
            dateEnd={list.dateEnd}
            onDateApply={list.onDateApply}
            onDateReset={list.onDateReset}
            companies={list.companies}
            companyIds={list.companyIds}
            onCompanyIdsApply={list.setCompanyIds}
            status={list.status}
            statuses={list.statuses}
            onStatusChange={list.setStatus}
            onExport={list.handleExport}
            isExporting={list.isExporting}
            exportDisabled={list.isLoading}
          />
        </div>

        <PromotionsBookTabs
          books={list.books}
          selectedBookId={list.selectedBookId}
          onChange={list.setSelectedBookId}
        />

        <div className="promotions-page__table-wrap reports__table">
          {(list.isLoading || list.isFetching) && <ProgressBar />}
          <PromotionsEligibilityTable
            mode={PROMOTIONS_LIST_MODES.REPORT}
            promotions={list.promotions}
          />
        </div>
      </div>
    </div>
  );
};
